var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07471 9.90727C11.1202 9.90727 12.7783 8.2491 12.7783 6.20364C12.7783 4.15817 11.1202 2.5 9.07471 2.5C7.02925 2.5 5.37108 4.15817 5.37108 6.20364C5.37108 8.2491 7.02925 9.90727 9.07471 9.90727ZM9.07471 8.51841C10.3531 8.51841 11.3895 7.48205 11.3895 6.20364C11.3895 4.92522 10.3531 3.88886 9.07471 3.88886C7.7963 3.88886 6.75994 4.92522 6.75994 6.20364C6.75994 7.48205 7.7963 8.51841 9.07471 8.51841ZM5.37063 10.8332C3.32517 10.8332 1.66699 12.4914 1.66699 14.5368V16.3886H10.3329C10.3329 16.3886 9.96991 15.9799 9.76869 15.6942C9.58539 15.434 9.34191 14.9998 9.34191 14.9998H3.05586C3.05586 13.4657 4.29949 12.222 5.83358 12.222H9.3475C9.3475 12.222 9.58845 11.7886 9.76869 11.5276C9.96515 11.2432 10.3329 10.8332 10.3329 10.8332H5.37063ZM13.5942 17.095C14.3432 17.095 15.0386 16.8659 15.6143 16.4739L17.1835 18.0431C17.4466 18.3062 17.8733 18.3062 18.1364 18.0431C18.3996 17.7799 18.3996 17.3533 18.1364 17.0901L16.5672 15.5209C16.9591 14.9453 17.1881 14.25 17.1881 13.5011C17.1881 11.5163 15.579 9.90727 13.5942 9.90727C11.6094 9.90727 10.0003 11.5163 10.0003 13.5011C10.0003 15.486 11.6094 17.095 13.5942 17.095ZM13.5942 15.7473C14.8347 15.7473 15.8404 14.7417 15.8404 13.5011C15.8404 12.2606 14.8347 11.255 13.5942 11.255C12.3537 11.255 11.348 12.2606 11.348 13.5011C11.348 14.7417 12.3537 15.7473 13.5942 15.7473Z",
    fill: "#2D72FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleSearch);
export default __webpack_public_path__ + "static/media/people_search.7ed3631400dbf83f3835abff7633e1bd.svg";
export { ForwardRef as ReactComponent };